import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateTariffServiceComponent } from './create-tariff-service.component';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    CreateTariffServiceComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule
  ],
  exports:[
    CreateTariffServiceComponent
  ]
})
export class CreateTariffServiceModule { }
